<template>
  <div class="d-flex">
    <date-picker v-e2e:filterDateFrom :start="true" v-model="filterDateFrom" />
    <date-picker
      v-e2e:filterDateTo
      :end="true"
      v-model="filterDateTo"
      class="ml-2"
    />
  </div>
</template>
<script>
import DatePicker from '@gid/vue-common/components/DatePicker.vue';
export default {
  components: {
    DatePicker,
  },
  props: ['value', 'dateType'],

  data: () => ({
    filterDateFrom: '',
    filterDateTo: '',
  }),
  created() {
    this.filterDateFrom = this.value
      ? JSON.parse(this.value)[`${this.dateType}_from`] || ''
      : '';
    this.filterDateTo = this.value
      ? JSON.parse(this.value)[`${this.dateType}_to`] || ''
      : '';
  },
  watch: {
    filterDateFrom(val) {
      if (!val) {
        if (this.filterDateTo) {
          this.$emit(
            'input',
            JSON.stringify({ [`${this.dateType}_to`]: this.filterDateTo }),
          );
        } else {
          this.$emit('input', null);
        }
      }

      if (val) {
        if (this.filterDateTo) {
          this.$emit(
            'input',
            JSON.stringify({
              [`${this.dateType}_from`]: val,
              [`${this.dateType}_to`]: this.filterDateTo,
            }),
          );
        } else {
          this.$emit(
            'input',
            JSON.stringify({ [`${this.dateType}_from`]: val }),
          );
        }
      }
    },
    filterDateTo(val) {
      if (!val) {
        if (this.filterDateFrom) {
          this.$emit(
            'input',
            JSON.stringify({ [`${this.dateType}_from`]: this.filterDateFrom }),
          );
        } else {
          this.$emit('input', null);
        }
      }

      if (val) {
        if (this.filterDateFrom) {
          this.$emit(
            'input',
            JSON.stringify({
              [`${this.dateType}_from`]: this.filterDateFrom,
              [`${this.dateType}_to`]: val,
            }),
          );
        } else {
          this.$emit('input', JSON.stringify({ [`${this.dateType}_to`]: val }));
        }
      }
    },
  },
};
</script>
<style scoped></style>
